<template>
  <div>
    <div class="fanhui_sy">
        <img src="./images/kcb_fanhui.png" @click="backLastPage" style="cursor: pointer;width: 20px;height: 20px;" />
        <h3 class="title">{{this.cateId.name }}</h3>
    </div>
    <!-- 首页课程 -->
    <div v-if="Isitthehomepage == 1" class="jinlier" style="overflow: hidden">
      <div v-for="item in courses" :key="item.id" class="course-itemw" @click="handleToCourseDetail(item)">
        <div class="course-item-img" :style="{ backgroundImage: 'url(' + item.cover + ')' }"></div>
        <div>
          <p class="course-item-name">{{ item.name }}</p>
        </div>
        <div class="course-item-info">
          <p class="course-item-check">开始学习</p>
        </div>
      </div>
    </div>
    <!-- 我的课程 -->
    <div v-if="Isitthehomepage == 2" style="min-width: 972px;overflow: hidden; background-color: #f5f6f7">
        <div class="onePersonClass">
            <ul class="course-content">
            <li class="course-item" v-for="item in courses" :key="item.id">
                <div class="course-img">
                <img :src="item.cover" alt="" />
                <p class="course-class">{{ item.period }}</p>
                </div>
                <div class="course-desc">
                <h4 class="course-title">{{ item.name }}</h4>
                <div class="course-time" v-if="item.start_time">
                    上课时间
                    <span>{{ item.start_time }}</span>
                </div>
                <div class="course-time-block" v-else></div>
                </div>
                <div class="study-state">
                <div class="study-time not-begin" v-if="!Number(item.endNum)">未开始学习</div>
                <div class="complete-study study-time" v-else></div>
                <div class="start-study" @click="handleStartStudy(item)">开始学习</div>
                </div>
            </li>
            </ul>
        </div>
    </div>
    <!-- 个人我的课程 -->
    <div v-if="Isitthehomepage == 3">
      <ul class="course-contenty">
        <li class="course-itemy" v-for="item in courses" :key="item.id">
          <div class="course-imgy">
            <img :src="item.cover" alt="" />
            <p class="course-classy">{{ item.period }}</p>
          </div>
          <div class="course-descy">
            <h4 class="course-titley">{{ item.name }}</h4>
            <div class="course-timey" v-if="item.start_time">
              上课时间
              <span>{{ item.start_time }}</span>
            </div>
            <div class="course-time-blocky" v-else></div>
          </div>
          <div class="study-statey">
            <div class="study-timey not-beginy" v-if="!Number(item.endNum)">未开始学习</div>
            <div class="complete-studyy study-timey" v-else></div>
            <div class="start-studyy" @click="handleStartStudy(item, 2)">开始学习</div>
          </div>
        </li>
      </ul>
    </div>
</div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
      data() {
        return {
          courses: [],
          curIdx: '',
        }
      },
      props: ['cateId', 'Isitthehomepage'],
      created() {
        this.listCourses()
      },
      computed: {
        ...mapState(['org_id']),
      },
      methods: {
        backLastPage() {
            this.$emit('fanhuisy')
        },
        // 查询课程列表
        listCourses() {
          const data = {
            packid: this.cateId.id,
            page: 1,
            num: 100000
          }
          if (this.Isitthehomepage == 1) {
            data.uid = this.org_id
          } else {
            data.packid = this.cateId.course_id
          }
          const prehy = this.Isitthehomepage == 1 ? '/app/getCorseFromPackage' : '/app/getAccessCorseFromPackage'
          // http://prehy_online.shkt.online
          this.$axios.post(process.env.VUE_APP_API_PRDHY + prehy, data).then((res) => {
            console.log('31115===', res)
            this.courses = res.data.data.list
          })

        },
        // 跳转课程详情
        handleToCourseDetail(item) {
          this.$router.push({ path: `/yueke3/${item.id}` })
        },
        handleStartStudy(val) {
          this.$router.push({ path: `/yueke3/${val.course_id}/${val.class_id}` })
        },
      },
    }
</script>
<style scoped>
.course-contenty {
  /* width: 940px; */
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}
.course-itemy {
  border-radius: 4px;
  border: #e8eaec 1px solid;
  width: 29%;
  min-width: 190px;
  height: 312px;
  margin: 0 20px 20px 0;
}

.course-imgy {
  position: relative;
  width: 100%;
  min-height: 125px;
  margin-bottom: 16px;
  overflow: hidden;
  border-radius: 4px 4px 0px 0px;
}
@media screen and (min-width: 1280px) {
  .course-img {
    height: 186px;
  }
}
@media screen and (max-width: 1280px) {
  .course-item {
    height: 260px;
  }
  .course-img {
    height: 125px;
  }
}

.course-imgy img {
  width: 100%;
  transition: all 0.5s;
}
.course-imgy img:hover {
  transform: scale(1.2);
}
.course-classy {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  height: 36px;
  line-height: 36px;
  color: #ffffff;
  font-size: 14px;
  padding-left: 20px;
  box-sizing: border-box;
}
.course-descy {
  padding: 0 10px;
  margin-bottom: 10px;
  position: relative;
}
.course-titley {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  color: #20242f;
  margin-bottom: 9px;
}
.course-timey {
  font-size: 14px;
  color: #808695;
}
.course-time-blocky {
  height: 18px;
}
.course-timey .course-timey span {
  margin-right: 10px;
}
.study-statey {
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
}
.study-statey div {
  width: 90px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 16px;
  font-size: 14px;
}
.study-statey .study-timey {
  text-align: left;
}
.complete-studyy {
  color: #808695;
}
.not-beginy {
  color: #ff9c18;
}
.start-studyy {
  border: 1px solid #1872ed;
  color: #1872ed;
  cursor: pointer;
}
.wrap {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  float: left;
  padding: 20px 30px;
  height: 880px;
  overflow-y: auto;
  scrollbar-width: none; 
  -ms-overflow-style: none; 
}
.wrap ::-webkit-scrollbar {
    display: none;
  }
.course-content {
  /* width: 940px; */
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}
.course-item {
  width: 300px;
  height: 320px;
  margin: 0 10px 20px 10px;
  background: #fff;
  border-radius: 4px;
}
ul li {
  list-style-type: none;
}
.course-img {
  position: relative;
  width: 100%;
  height: 200px;
  margin-bottom: 16px;
  overflow: hidden;
  border-radius: 4px 4px 0px 0px;
}
.course-img img {
  width: 100%;
  height: 100%;
}
.course-class {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  height: 36px;
  line-height: 36px;
  color: #ffffff;
  font-size: 14px;
  padding-left: 20px;
  box-sizing: border-box;
}
.course-desc {
  padding: 0 20px;
  margin-bottom: 5px;
  position: relative;
}
.course-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  color: #20242f;
  margin-bottom: 9px;
}
.course-time {
  font-size: 14px;
  color: #808695;
}
.course-time-block {
  height: 18px;
}
.course-time .course-time span {
  margin-right: 10px;
}
.study-state {
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
}
.study-state div {
  width: 91px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 17px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  font-size: 14px;
}
.study-state .study-time {
  text-align: left;
}
.complete-study {
  color: #808695;
}
.not-begin {
  color: #FFC102;
}
.studying {
  color: #10a675;
}
.start-study {
  border: 1px solid #1872ed;
  color: #1872ed;
  cursor: pointer;
}
p {
  margin: 0;
  padding: 0;
}
.title {
  font-size: 20px;
  color: #202020;
  margin-bottom: 6px;
  margin-top: 6px;
  margin-left: 12px;
}
.fanhui_sy {
    display: flex;
    align-items: center;
}
.jinlier {
  width: 100%;
  margin-top: 30px;
}
.course-itemw {
  border-radius: 4px;
  width: 300px;
  height: 300px;
  float: left;
  opacity: 1;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0px 5px 0px rgb(0 0 0 / 1%);
  margin: 0 10px 20px 10px;
  cursor: pointer;
}
.course-item-img {
  border-radius: 4px 4px 0px 0px;
  width: 300px;
  height: 200px;
  background-size: cover;
  background-position: center;
}

.course-item-name {
  font-size: 18px;
  font-family: MicrosoftYaHei;
  color: #20242f;
  padding-left: 20px;
  margin-top: 15px;
  white-space:nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
}
.course-item-info {
  margin-top: 15px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
}
.course-item-info a {
  text-decoration: none;
}

.course-item-num {
  font-size: 14px;
  color: #808695;
  float: left;
  align-self: center;
}

.course-item-check {
  width: 91px;
  height: 32px;
  border: 1px solid #1872ed;
  border-radius: 16px;
  text-align: center;
  line-height: 32px;
  color: #1872ed;
  font-size: 14px;
  margin-left: auto;
}
.onePersonClass{
  margin: 0 auto;
  min-height: 200px;
  overflow: hidden;
  background: #f5f6f7;
  margin-bottom:20px;
}
</style>